import {Api, ApiExport} from '../../Api.js'

const RESOURCE = 'event'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    all(query) {
        return Api().get(this.resource + '/all'  + (query ? query : '') )
    },
    export(id, query, filename) {

        return ApiExport(filename).get(this.resource + '/' + id + '/export' + (query ? query : ''),
            {
                responseType: 'blob', // important
            });
    },
}


// WEBPACK FOOTER //
// ./src/modules/event/EventService.js